import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fialrest/ui/tipografias.css'
import '@fialrest/ui/tokens.css'
import './mostrador.css'
import { Mostrador } from './Mostrador.js'
import { slugDeLaUrl } from './slug.js'

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Falta el nodo #raiz')

createRoot(raiz).render(
  <StrictMode>
    <Mostrador slug={slugDeLaUrl(window.location.pathname)} />
  </StrictMode>,
)
